import React from 'react';
import { ChevronRight, CheckCircle2 } from 'lucide-react';

export function NavigationButtons({
  currentStep,
  totalSteps,
  isLastQuestion,
  onBack,
  onNext,
  onSubmit,
  isSubmitting = false
}) {
  // Use isLastQuestion prop if provided, otherwise fallback to old behavior
  const isLastStep = isLastQuestion !== undefined ? isLastQuestion : currentStep === totalSteps - 1;

  return (
    <div className="flex gap-3 sm:gap-4 mt-6 sm:mt-8">
      {currentStep > 0 && (
        <button
          onClick={onBack}
          disabled={isSubmitting}
          className="px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Voltar
        </button>
      )}

      {isLastStep ? (
        <button
          onClick={onSubmit}
          disabled={isSubmitting}
          className="flex-1 flex items-center justify-center gap-2 px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base bg-gradient-to-r from-amber-400 to-orange-500 text-white rounded-lg hover:from-amber-500 hover:to-orange-600 transition font-medium shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 sm:h-5 sm:w-5 border-b-2 border-white"></div>
              Enviando...
            </>
          ) : (
            <>
              Enviar Pesquisa
              <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5" />
            </>
          )}
        </button>
      ) : (
        <button
          onClick={onNext}
          disabled={isSubmitting}
          className="flex-1 flex items-center justify-center gap-2 px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base bg-gradient-to-r from-amber-400 to-orange-500 text-white rounded-lg hover:from-amber-500 hover:to-orange-600 transition font-medium shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Próxima
          <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
        </button>
      )}
    </div>
  );
}
